import { Component, createEffect, onCleanup, Show } from 'solid-js'
import { createStore } from 'solid-js/store'

interface Props {
    shouldStart?: boolean
    end: number
    /** in milliseconds */
    duration?: number
    format?: boolean
    start?: number
    onEnd?(): void
}

export const Counter: Component<Props> = props => {
    let timer: ReturnType<typeof setInterval> | null = null

    const [state, setState] = createStore<{ counter: number }>({
        counter: props.start || 0,
    })

    createEffect(() => {
        const shouldStart = props.shouldStart ?? true

        if (!shouldStart) {
            if (timer !== null) {
                clearInterval(timer)
                timer = null
            }
            return
        }

        if (timer !== null) {
            clearInterval(timer)
            timer = null
        }

        const interval = 20
        const totalDuration = Math.max(props.duration || 1000, interval)
        const iterations = totalDuration / interval
        const steps = Math.max(Math.ceil(props.end / iterations), 1)

        timer = setInterval(() => {
            setState('counter', current => {
                const nextValue = current + steps
                if (nextValue >= props.end) {
                    if (timer !== null) {
                        clearInterval(timer)
                        timer = null
                    }
                    props.onEnd?.()
                    return props.end
                }
                return nextValue
            })
        }, interval)
    })

    onCleanup(() => {
        if (timer !== null) clearInterval(timer)
    })

    return (
        <span class='counter-span'>
            <Show when={props.format} fallback={state.counter}>
                {state.counter.toLocaleString()}
            </Show>
        </span>
    )
}
